import { Modal } from "antd";
import React from "react";
import { svg } from "../../../../../Assets/svg";
import { RootState, useAppSelector } from "../../../../../store";
import { BtnLoader } from "../../../../../Components/Components";

const OverLoadConfirmationModal = ({
  visible,
  setIsModalVisible,
  isOverDispatchData,
  onSucess,
}: any) => {
  const { updateDispatchActualManageLoading } = useAppSelector(
    (state: RootState) => state.loading,
  );
  const onClose = () => {
    setIsModalVisible(false);
  };
  return (
    <Modal
      title={
         <div className="text-center fs-4 fw-bolder lh-m">
          Please confirm over-dispatch transfer
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
            disabled={updateDispatchActualManageLoading}
          >
            CLOSE
          </button>
          <button
            type="button"
            className="btn btn-lg btn-primary min-w-130"
            onClick={onSucess}
            disabled={updateDispatchActualManageLoading}
          >
            {updateDispatchActualManageLoading ? <BtnLoader /> : "YES, CONFIRM"}
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div className="modal-body page-form">
        <ul className="mb-0 mt-3">
          {isOverDispatchData?.map((c: any, i: any) => (
            <li className="fs-6 mb-2 text-4a4a4a">{c}</li>
          ))}
        </ul>
      </div>
    </Modal>
  );
};

export default OverLoadConfirmationModal;
